import{RECEIVE_CLIENT_INFORMATION}from"../constants/ActionTypes";import{main$}from"./main";/**
 * Gets triggered after the client information was updated
 * @type {Observable}
 */export var clientInformationDidUpdate$=main$.filter(function(_ref){var action=_ref.action;return action.type===RECEIVE_CLIENT_INFORMATION;});